import { useTranslation } from 'react-i18next';

export const useCartProductAvailability = (
  stock: string
): {
  isInStock: boolean;
  stockString: string;
} => {
  const { t } = useTranslation();
  const isInStock = stock === 'Available' || stock === 'Disponible';

  return {
    isInStock,
    stockString: isInStock ? t('AVAILABLE') : t('UNAVAILABLE'),
  };
};
